import Image from '../../../../components/Image'
import Modal from "../../../../components/Modal";
import WomanReading from "../../../../assets/woman-reading.svg";
import {
  Title,
  Text,
  ButtonViewLater,
  Flex,
  ButtonExporeNow
} from "./styles";
import { connect, useDispatch } from "react-redux";
import { savePreference } from "../../../../store/actions/preferences";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Preference } from "../../../../types/preferences";
import { Group } from "../../../../types";
import { hideModal, showModal } from "../../../../store/actions/modal";
import { CategoryDto } from "../../../../types/category";
import { showPreference } from '../../../../helpers/preferenceVisible';
import UnlockedCategoryMedal from '../../../components/UnlockedCategoryMedal';
import { roundedHumanUnlockTime, roundedToUnlockCategoryTime } from '../../../../helpers/humanUnlockTime';
import { isOwnGroup } from '../../../../helpers/isOwnGroup';

interface ComponentProps {
  preferences: Preference[];
  preferencesStates;
  allCategories: CategoryDto[];
  allCategoriesStates: {
    loading: boolean
  }
  group: Group
  groupStates: {
    loading: boolean
  }
  userInformation
}

export const Component = ({
  preferences,
  preferencesStates,
  group,
  groupStates,
  allCategories,
  allCategoriesStates,
  userInformation,
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [id, setId] = useState("");

  const isOwnser = useMemo(() => {
    return isOwnGroup({ group, expertId: userInformation?.expert?.id })
  }, [group, userInformation]);

  const unlockedCategory: CategoryDto | undefined = useMemo(() => {
    if (allCategories && preferences && preferencesStates.loading === false) {
      const sortCategories = allCategories
        ?.filter(item => item?.is_unlockable && item?.locked_ordinal !== undefined)
        ?.sort((a, b) => (b.locked_ordinal ?? Infinity) - (a.locked_ordinal ?? Infinity))
        ?.filter(item => item?.user_access_data?.is_unlocked)

      const lastUnlockedCategory = sortCategories?.[0];

      if (!lastUnlockedCategory) return undefined;

      const id = `unlocked-category-modal-${lastUnlockedCategory.id}`;

      const show = showPreference({
        preferences,
        preferencesStates,
        id,
      });

      if (show) {
        setId(id);
      }

      return show ? lastUnlockedCategory : undefined;
    }

    return undefined
  }, [allCategories, preferences, preferencesStates]);

  const humanReadableTime = useMemo(() => {
    if (!unlockedCategory) {
      return ''
    }

    return roundedToUnlockCategoryTime(unlockedCategory)
  }, [unlockedCategory]);

  const getLink = useCallback(() => {
    return `/group/${group?.id}/p/c/${unlockedCategory?.id}`
  }, [group, unlockedCategory])


  const onClose = useCallback(() => {
    if (!!unlockedCategory && !!id) {
      dispatch(
        savePreference({
          preferenceSlug: id,
          preferenceValue: false,
        })
      );
    }
  }, [unlockedCategory, id])


  useEffect(() => {
    if (!!id && !!unlockedCategory) {
      dispatch(showModal(id));
    }
  }, [id, unlockedCategory]);


  if (isOwnser || !userInformation || !group || groupStates.loading || !allCategories || allCategoriesStates.loading || !unlockedCategory) {
    <></>
  }

  return (
    <Modal
      name={id}
      width="650"
      onClose={onClose}
    >
      {!!unlockedCategory && (
        <>
          <Flex>
            <UnlockedCategoryMedal category={unlockedCategory} width="98px" height="auto" />
          </Flex>
          <div style={{ height: 22 }} />
        </>
      )}

      <Title>
        ¡Felicidades! has desbloqueado una nueva categoría.
      </Title>

      <div style={{ height: 22 }} />

      <Text>
        Después de {humanReadableTime} en {group?.group_name}, ahora tenés acceso a: {unlockedCategory?.name}
      </Text>

      <div style={{ height: 22 }} />

      <Flex style={{ gap: 12 }}>
        <ButtonViewLater
          onClick={() => {
            dispatch(hideModal());
            onClose();
          }}
        >
          Ver despues
        </ButtonViewLater>
        <ButtonExporeNow
          onClick={() => {
            dispatch(hideModal());
            onClose();
          }}
          href={getLink()}
          target="_blank"
        >
          Explorar ahora 🎉
        </ButtonExporeNow>
      </Flex>
    </Modal>
  );
};

const state = ({ groupStore, preferencesStore, categoryStore, userStore }) => {
  const { data: allCategories, states: allCategoriesStates } = categoryStore.allCategories;
  const { data: group, states: groupStates } = groupStore.group;
  const { data: preferences, states: preferencesStates } = preferencesStore.preferences;
  const { data: userInformation } = userStore.information;

  return {
    userInformation,
    allCategories,
    allCategoriesStates,
    group,
    groupStates,
    preferences,
    preferencesStates,
  };
};

export default connect(state)(Component);
